import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import Entities from 'html-entities/lib/html5-entities';
import toTitleCase from 'to-title-case';

import InnerWrapper from '../components/inner-wrapper';
import AnimatedHeading from '../components/animated-heading';
import BlogListing from '../components/blog-listing';
import Pagination from '../components/pagination';

const entities = new Entities();

const blogIndex = css``;

const blogIndexWrapper = css``;

const blogGrid = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const NavLink = props => {
  if (!props.test) {
    return <Link to={props.url}>{props.text}</Link>;
  }
  return <span>{props.text}</span>;
};

NavLink.propTypes = {
  test: PropTypes.bool,
  url: PropTypes.string,
  text: PropTypes.string,
};

const BlogIndex = ({ pathContext }) => {
  const {
    group,
    index,
    pageCount,
    pathPrefix,
    tag,
    category,
    isTaggedPage,
    isCategoryPage,
  } = pathContext;
  const first = index === 1;
  const last = index === pageCount;
  const previousUrl = index - 1 === 1 ? `/${pathPrefix}` : `/${pathPrefix}/page/${index - 1}`;
  const nextUrl = `/${pathPrefix}/page/${index + 1}`;

  const helmetTitle = (() => {
    const paged = index !== 1 ? ` &bull; Page ${index} of ${pageCount}` : '';
    if (!isTaggedPage && !isCategoryPage) return `Blog${paged}`;
    return isTaggedPage
      ? `&ldquo;${toTitleCase(tag)}&rdquo; Archives${paged}`
      : `&ldquo;${toTitleCase(category)}&rdquo; Archives${paged}`;
  })();

  const blogTitle = (() => {
    if (!isTaggedPage && !isCategoryPage) return 'Our Blog';
    return isTaggedPage
      ? `Showing posts tagged &ldquo;${toTitleCase(tag)}&rdquo;`
      : `Showing posts under &ldquo;${toTitleCase(category)}&rdquo;`;
  })();

  return (
    <div className={blogIndex}>
      <InnerWrapper className={blogIndexWrapper} narrow>
        <Helmet>
          <title>{entities.decode(helmetTitle)}</title>
        </Helmet>

        <AnimatedHeading text={entities.decode(blogTitle)} animated={false} />

        <section className={blogGrid}>
          {group.map(({ node }, idx) => (
            <BlogListing
              isLarge={Boolean(idx === 0 && group.length % 2)}
              key={node.id}
              node={node}
            />
          ))}
        </section>

        <Pagination
          isFirstPage={first}
          isLastPage={last}
          previousUrl={previousUrl}
          nextUrl={nextUrl}
          currentPage={index}
          totalPages={pageCount}
          countFormat={'Page %s of %s'}
          previousLinkText={null}
          nextLinkText={null}
          isCompact={true}
        />
      </InnerWrapper>
    </div>
  );
};

BlogIndex.propTypes = {
  data: PropTypes.object,
  pathContext: PropTypes.object,
};

export default BlogIndex;



// WEBPACK FOOTER //
// ./src/templates/blog-index.js